import React from "react";

type Props = {
  rows?: number;
};

const Cell = ({ className }: { className: string }) => (
  <div className={`h-3 rounded bg-gray-200 animate-pulse ${className}`} />
);

export const UsersTransactionsTableSkeleton: React.FC<Props> = ({ rows = 10 }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, i) => (
        <tr key={i} className="text-center odd:bg-white even:bg-gray-50">
          <td className="px-4 py-3 border-t border-gray-200">
            <Cell className="w-32 mx-auto" />
          </td>
          <td className="px-4 py-3 border-t border-gray-200">
            <Cell className="w-20 mx-auto" />
          </td>
          <td className="px-4 py-3 border-t border-gray-200">
            <div className="flex justify-center">
              <div className="h-6 w-20 rounded-full bg-gray-200 animate-pulse" />
            </div>
          </td>
          <td className="px-4 py-3 border-t border-gray-200">
            <div className="flex justify-center">
              <div className="h-6 w-16 rounded-full bg-gray-200 animate-pulse" />
            </div>
          </td>
          <td className="px-4 py-3 border-t border-gray-200">
            <Cell className="w-24 mx-auto" />
          </td>
          <td className="px-4 py-3 border-t border-gray-200">
            <div className="flex justify-center">
              <div className="h-5 w-24 rounded-full bg-gray-200 animate-pulse" />
            </div>
          </td>
          <td className="px-4 py-3 border-t border-gray-200">
            <div className="flex justify-center">
              <div className="h-8 w-12 rounded bg-gray-200 animate-pulse" />
            </div>
          </td>
        </tr>
      ))}
    </>
  );
};

export default UsersTransactionsTableSkeleton;
